import { Component } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NavService } from './providers/nav.service';
// import { Cookie } from 'ng2-cookies/ng2-cookies';
// import { AuthService, FacebookLoginProvider, SocialUser } from 'angularx-social-login';
// import { SocialmediabuttonsComponent } from './commonComponents/socialmediabuttons/socialmediabuttons.component';
// import facebookLogin from 'facebook-login';
// const api = facebookLogin({ appId: '325973485413885' });
// declare let FB: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'ChalkFaders';
  userDet: any = {};
  isLogin = false;
  subscription: Subscription;

  // user: SocialUser;
  loggedIn: boolean;
  
  constructor(
    public route: Router,
    // private authService: AuthService,
    // private socialMedia: SocialmediabuttonsComponent,
    private navService: NavService
  ) {

    this.route.events
    .subscribe((event) => {
      if (event instanceof NavigationStart) {
        window.scrollTo(0, 0);
      }
    });

    // api.whenLoaded().then((response) => {
    //   console.log(response);
    //   api.getLoginStatus().then((response) => {
    //     console.log(response);
    //   }, (err) => {
    //     console.log(err);
    //   });
    // }, (err) => {
    //   console.log(err);
    // });

    //   FB.getLoginStatus(function (response) {
    //     // FB.logout(function (response) {
    //       console.log("Logged In!");

    //     // });
    //   }, (err) => {
    //     console.log(err);
    //   });

    //   this.userDet = JSON.parse(localStorage.getItem("userDetails"));

    //   FB.api('/me', {  access_token : this.userDet.accessToken } ,function(response) {
    //     console.log(response);
    // }, (err) => {
    //   console.log(err);
    // });



    this.subscription = this.navService.navItem$.subscribe(item => {
      this.userDet = JSON.parse(localStorage.getItem('userDetails'));
      // this.userDet = JSON.parse(localStorage.getItem("loginDetails"));
      if (this.userDet) {
        this.isLogin = true;
        if (item == 'item') {
          this.route.navigate(['/DashBoard']);
        }
      } else {
        this.isLogin = false;
        // this.authService.signOut()
        // .then((data) => {
        //   console.log("Success :" + data);
        // }).catch((ex) => {
        //   console.log("Exception :" + ex)
        // });
        if (this.route.url === "/") {
          return;
        }
        if (item === 'SignUp') {
          this.route.navigate(['/SignUp']);
        } else {
          this.route.navigate(['/SignIn']);
        }

      }
    });
  
  }

  // ngOnInit() {
  //   this.authService.authState.subscribe((user) => {
  //     this.user = user;
  //     this.loggedIn = (user != null);
  //     console.log(this.user);
  //   });
  // }

  // signInWithFB(): void {
  //   this.authService.signIn(FacebookLoginProvider.PROVIDER_ID);
  // }

  // signOut(): void {
  //   this.authService.signOut();
  // }
  
}
